<script setup lang="ts">
defineOptions({ inheritAttrs: false })
import type { NavButtonName } from '@/composables/settings/definition'
import { currentUser } from '@/composables/user/users'
import { STORAGE_KEY_BOTTOM_NAV_BUTTONS } from '@/constants'
import { useLocalStorage } from '@vueuse/core'
import { computed, nextTick, onMounted, ref, type Component } from 'vue'
import NavHome from './Button/NavHome.vue'
import NavPage from './Button/NavPage.vue'
import NavSchedule from './Button/NavSchedule.vue'
import NavMe from './Button/NavMe.vue'
import { rem2Px } from '@/utils/util'
import { originalWindowHeight } from '@/composables/settings/definition'

interface NavButton {
  name: string
  component: Component
}

const navButtons: NavButton[] = [
  { name: 'home', component: NavHome },
  { name: 'life', component: NavPage },
  { name: 'schedule', component: NavSchedule },
  { name: 'me', component: NavMe }
]

const defaultSelectedNavButtonNames: NavButtonName[] = currentUser.value
  ? ['home', 'life', 'schedule', 'me']
  : ['home', 'life', 'schedule', 'me']
const selectedNavButtonNames = useLocalStorage<NavButtonName[]>(
  STORAGE_KEY_BOTTOM_NAV_BUTTONS,
  defaultSelectedNavButtonNames
)

const selectedNavButtons = computed(() =>
  selectedNavButtonNames.value.map((name) => navButtons.find((navButton) => navButton.name === name))
)

// only one icon can be lit up at the same time
// const moreMenuVisible = ref(true)

const safeAreaBottom = ref(0)

onMounted(() => {
  // 监听微信导航栏变化
  window.addEventListener('resize', checkWechatNav)
  checkWechatNav()
})

const checkWechatNav = () => {
  const currentHeight = window.innerHeight
  const isNavShow = currentHeight < originalWindowHeight

  safeAreaBottom.value = 0

  // console.log(
  //   'safeAreaBottom:',
  //   safeAreaBottom.value,
  //   'isNavShow:',
  //   isNavShow,
  //   'originalWindowHeight:',
  //   originalWindowHeight,
  //   'currentHeight:',
  //   currentHeight,
  //   'document.documentElement.clientHeight:',
  //   document.documentElement.clientHeight,
  //   'clientHeight'
  // )

  // 动态设置CSS变量或类名
  // if (safeAreaBottom.value > 0) {
  //   document.documentElement.style.setProperty('--safe-area-inset-bottom', `${safeAreaBottom.value}px`)
  //   console.log('11', isIOS(), safeAreaBottom.value)
  // } else {
  //   if (isIOS() && !isNavShow) {
  //     console.log('22', isIOS(), isNavShow)
  //     safeAreaBottom.value = rem2Px(1.5)
  //   }
  // }

  // 获取存储安全区域信息的元素
  const safeAreaElement = document.getElementById('safe-area-inset')
  // 获取计算后的样式
  if (typeof window !== 'undefined' && safeAreaElement) {
    const computedStyle = getComputedStyle(safeAreaElement)
    const paddingBottom = computedStyle.getPropertyValue('padding-bottom')
    safeAreaBottom.value = parseInt(paddingBottom, 10)
  }
  // // 转换为数字（去除单位）
  // const safeAreaInsetBottomValue = parseFloat(safeAreaInsetBottom.replace('px', ''))
  // console.log('safeAreaInsetBottomValue: ', safeAreaInsetBottomValue)
}

const navHeight = computed(() => {
  return `${rem2Px(3.75) + safeAreaBottom.value}px`
})
</script>

<template>
  <!-- This weird styles above are used for scroll locking, don't change it unless you know exactly what you're doing. -->
  <div
    v-bind="$attrs"
    min-h-15
    border="t light"
    bg-base-90
    flex
    flex-row
    items-start
    text-xl
    backdrop-blur-sm
    of-y-scroll
    scrollbar-hide
    overscroll-none
    class="after-content-empty after:h-[calc(100%+0.5px)] after:w-0.1px after:pointer-events-none no-scrollbar">
    <Component
      :is="navButton!.component"
      v-for="navButton in selectedNavButtons"
      :key="navButton!.name"
      class="safe-margin"
      :active-class="'text-primary'" />
  </div>
  <!-- 用于 JS 检测安全区域高度的隐藏元素 -->
  <div id="safe-area-inset" class="safe-area-probe" aria-hidden="true" />
</template>
<style lang="scss" scoped>
.safe-margin {
  margin-top: 0.45rem;
  margin-bottom: env(safe-area-inset-bottom, 0px);
  transition: margin-bottom 0.3s ease;
}

/* 用于 JS 读取安全区域高度的隐藏探针元素 */
.safe-area-probe {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 0;
  height: 0;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  pointer-events: none;
  visibility: hidden;
}
</style>
